<template>
  <div class="Item">
    <div class="Item__icon">
      <Alpha v-if="props.iconName === 'alpha'" />
      <Signal v-else-if="props.iconName === 'signal'" />
      <Calendar v-else-if="props.iconName === 'calendar'" />
      <Podcasts v-else-if="props.iconName === 'podcasts'" />
      <Forecasters v-else-if="props.iconName === 'forecasters'" />
      <Chat v-else-if="props.iconName === 'chat'" />
    </div>
    <p class="Item__ttl">{{ props.title }}</p>
    <p class="Item__text">{{ props.text }}</p>
  </div>
</template>

<script setup>
  import { Props } from './props';
  //----------------------------------
  import Alpha from './icons/Alpha.vue';
  import Signal from './icons/Signal.vue';
  import Calendar from './icons/Calendar.vue';
  import Podcasts from './icons/Podcasts.vue';
  import Forecasters from './icons/Forecasters.vue';
  import Chat from './icons/Chat.vue';
  //----------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>